import { render, staticRenderFns } from "./BlockBlogListItemCategories.vue?vue&type=template&id=6d09e604&scoped=true&"
import script from "./BlockBlogListItemCategories.vue?vue&type=script&lang=js&"
export * from "./BlockBlogListItemCategories.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogListItemCategories.vue?vue&type=style&index=0&id=6d09e604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09e604",
  null
  
)

export default component.exports